
<template>
  <vue-pikaday 
    ref="pikaday"
    v-model="date"
    placeholder="TT.MM.YYYY"
    :options="pikadayOptions" 
  />
</template>

<script>
  import moment from 'moment';
  import '@netcz/vue-pikaday';

  export default {
    props: [
        'value',
        'minDate',
        'maxDate'
    ],
    data() {
        return {
            date: null,
            pikadayOptions: {
                format: 'DD.MM.YYYY',
                yearRange: 50,
                i18n: {
                    previousMonth : 'Voriger Monat',
                    nextMonth     : 'Nächster Monat',
                    months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
                    weekdays      : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
                    weekdaysShort : ['So','Mo','Di','Mi','Do','Fr','Sa']
                }   
            }
        }
    },

    methods: {
        setDate(value) {
            if (value !== null && value !== this.date) {
              this.date = moment( value, [this.pikadayOptions.format, 'YYYY-MM-DD'] ).toDate();
            }
        },

        setBounds(min, max) {
            if (min != null && moment(min).isValid) {
                this.$refs.pikaday.pikaday.setMinDate(moment(min).toDate());
            }

            if (max != null && moment(max).isValid) {
                this.$refs.pikaday.pikaday.setMaxDate(moment(max).toDate());
            }
         }
    },

    watch: {
        value(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.setDate(newValue);
            }
        },

        date(newDate, oldDate) {
            if (newDate !== oldDate) {
                this.$emit('input', newDate);
            }
        }
    },

    mounted() {
        this.setDate(this.value);
        this.setBounds(this.minDate, this.maxDate)
    }
  }
</script>